import {
  Box,
  Typography,
  Button,
  makeStyles,
  CardMedia,
} from "@material-ui/core";
import { useTranslate } from "react-admin";
import { useHistory } from "react-router-dom";

import CorrectIcon from "../../../assets/correct-blue.png";

const useSuccessPageStyles = makeStyles((theme) => ({
  allContainer: {
    margin: "0 auto",
    width: 581,
    height: 489,
    marginTop: 13,
    backgroundColor: "#ebebeb",
  },
  center: {
    margin: "0 auto",
  },
  image: {
    marginTop: 144,
    width: 152,
    height: 152,
  },
  title: {
    marginTop: 31,
  },
  subtitle: {
    fontSize: 32,
  },
  buttonContainer: {
    marginTop: 96,
    display: "flex",
    justifyContent: "space-around",
    width: 581,
  },
  button: {
    width: 272,
    height: 69,
  },
  buttonGotoProfile: theme.generalButtonPotentialPrimary,
  buttonLabelPrimary: theme.buttonLabelPrimaryPotentialOutlined,
  buttonLabelPrimaryOutlined: theme.buttonLabelPrimaryPotentialOutlined,
}));

const SuccessView = ({ potentialId }) => {
  const classes = useSuccessPageStyles();
  const translate = useTranslate();
  //Load memberInfo to confirm
  // const { data, loading, error } = useGetOne("customers", customerId);
  const history = useHistory();

  //if (loading) return null;

  return (
    <Box>
      <CardMedia
        className={[classes.center, classes.image]}
        image={CorrectIcon}
        title={translate("ra.text.registerSuccess.congratulation")}
      />
      <Typography
        variant="h2"
        align="center"
        className={[classes.center, classes.title]}
      >
        {translate("ra.text.registerSuccess.congratulation")}
      </Typography>
      <Typography
        align="center"
        className={[classes.center, classes.subtitle]}
        noWrap
      >
        Potential customer has been created
      </Typography>
      <Box className={[classes.center, classes.buttonContainer]}>
        <Button
          variant="outlined"
          color="primary"
          className={classes.button}
          onClick={() =>
            history.push({
              pathname: "/",
              //  state: { member: data },
            })
          }
        >
          <Typography className={classes.buttonLabelPrimaryOutlined}>
            Go to Homepage
          </Typography>
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.buttonGotoProfile}
          onClick={() =>
            history.push({
              pathname: `/ci/potential/profiles/${potentialId}`,
              //  state: { member: data },
            })
          }
        >
          Go to Profile
        </Button>
      </Box>
    </Box>
  );
};

export default SuccessView;
